import { createContext, useContext, useEffect, useState } from "react";

export const translations = {
    nl: {
        nav: {
            home: "Home",
            diensten: "Diensten",
            werkgebied: "Werkgebied",
            onzeTaxi: "Onze taxi",
            overOns: "Over ons",
            boeken: "Boeken",
            contact: "Contact",
            bookCta: "Boek een rit",
            call: "Bellen",
            whatsapp: "WhatsApp",
        },
        hero: {
            eyebrow: "Uw lokale taxi in Drunen — 24/7",
            line1: "Onderweg",
            line2a: "zonder ",
            line2b: "omwegen.",
            sub: "Persoonlijk en betrouwbaar taxivervoer vanuit Drunen. Dag en nacht bereikbaar. U spreekt direct met de chauffeur en weet vooraf waar u aan toe bent.",
            call: "Bel direct",
            whatsapp: "WhatsApp",
            book: "Boek een rit",
            scrollLabel: "Scroll naar diensten",
            usps: [
                { title: "24/7 beschikbaar", text: "Dag en nacht bereikbaar" },
                { title: "Prijs vooraf afgesproken", text: "Geen verrassingen achteraf" },
                { title: "Direct de chauffeur", text: "U spreekt de chauffeur zelf" },
            ],
        },
        marquee: [
            "24/7 bereikbaar",
            "Luchthavenvervoer",
            "Prijs vooraf afgesproken",
            "Thuis in Drunen",
            "Zakelijk vervoer",
            "Direct de chauffeur",
            "Schiphol & Eindhoven Airport",
            "Lange afstand",
        ],
        services: {
            eyebrow: "Diensten",
            title: "Waar rijden wij u heen?",
            text: "Van korte rit in Drunen tot luchthavenvervoer door heel Nederland en Europa. Elke rit persoonlijk geregeld, met de prijs vooraf afgesproken.",
            items: [
                {
                    title: "Luchthavenvervoer",
                    text: "Comfortabel vervoer van deur tot terminal. Wij volgen uw planning en halen u op tijd op, ook voor vroege vluchten en late aankomsten.",
                    cta: "Luchthavenrit boeken",
                },
                {
                    title: "Straattaxi",
                    text: "Snelle taxiritten in Drunen en omgeving. Bel en wij zijn onderweg.",
                    cta: "Taxi nodig? Bel direct",
                },
                {
                    title: "Zakelijk vervoer",
                    text: "Representatief vervoer voor bedrijven, afspraken, medewerkers en gasten. Factuurmogelijkheid beschikbaar.",
                    cta: "Zakelijke rit aanvragen",
                },
                {
                    title: "Dagelijkse ritten",
                    text: "Voor bijvoorbeeld ziekenhuis, boodschappen, familiebezoek en afspraken. Zorgvuldig en op tijd.",
                    cta: "Plan uw rit",
                },
                {
                    title: "Groepsvervoer",
                    text: "Vervoer voor meerdere personen en groepen, afgestemd op uw gezelschap en planning.",
                    cta: "Groepsrit aanvragen",
                },
                {
                    title: "Evenementen & feesten",
                    text: "Veilig heen en terug, zonder zorgen over parkeren of vervoer na afloop.",
                    cta: "Reserveer vervoer",
                },
                {
                    title: "Lange afstand",
                    text: "Comfortabel vervoer door heel Nederland en op aanvraag naar bestemmingen in Europa.",
                    cta: "Vraag een prijs aan",
                },
            ],
            longWa: "Hallo Taxi Drunnen, ik wil graag een prijs aanvragen voor een langeafstandsrit.",
        },
        taxi: {
            eyebrow: "Onze taxi",
            title: "Twee zwarte auto's. Één standaard.",
            text: "U reist altijd in een verzorgde, zwarte auto met ruimte voor u en uw bagage. Heeft u geen voorkeur? Dan plannen wij de auto die het beste bij uw rit past.",
            vehicles: [
                {
                    name: "Volkswagen Passat Variant",
                    code: "TD—01",
                    plate: "GZ-839-F",
                    tagline: "Comfortabele stationwagen — de stille kracht voor lange ritten.",
                    features: ["Zwart", "Verzorgd", "Comfortabel", "Ruim", "Geschikt voor korte en lange ritten"],
                    specs: [
                        { label: "Bouwjaar", value: "2015" },
                        { label: "Zitplaatsen", value: "5" },
                        { label: "Bagageruimte", value: "Ruim" },
                    ],
                    alt: "De zwarte Volkswagen Passat Variant van Taxi Drunnen (GZ-839-F)",
                },
                {
                    name: "Lynk & Co 01",
                    code: "TD—02",
                    plate: "JBT-88-B",
                    tagline: "Moderne plug-in hybride SUV — stil in de stad, soepel op de snelweg.",
                    features: ["Zwart", "Plug-in hybride", "Modern en comfortabel", "Ruim", "Geschikt voor korte en lange ritten"],
                    specs: [
                        { label: "Bouwjaar", value: "2022" },
                        { label: "Zitplaatsen", value: "5" },
                        { label: "Aandrijving", value: "Hybride" },
                    ],
                    alt: "De zwarte Lynk & Co 01 van Taxi Drunnen (JBT-88-B)",
                },
            ],
        },
        why: {
            eyebrow: "Waarom Taxi Drunnen",
            title: "Geen callcenter. Gewoon uw chauffeur.",
            text: "Taxi Drunnen is nieuw en lokaal. Daardoor krijgt u persoonlijke aandacht en korte lijnen. U bent geen nummer in een systeem.",
            points: [
                { title: "Direct contact", text: "U spreekt rechtstreeks met de chauffeur die uw rit verzorgt." },
                { title: "Prijs vooraf", text: "De ritprijs wordt vóór vertrek afgesproken. Geen verrassingen achteraf." },
                { title: "Dag en nacht", text: "24 uur per dag, 7 dagen per week bereikbaar." },
            ],
            banner: "Vraag over een rit, prijs of bestemming? App ons gerust — u krijgt persoonlijk antwoord.",
            bannerCta: "Stel uw vraag via WhatsApp",
        },
        area: {
            eyebrow: "Werkgebied",
            title: "Thuis in Drunen. Onderweg door heel Nederland.",
            text: "Drunen is onze thuisbasis. Vanuit hier rijden wij dagelijks in de regio en ver daarbuiten.",
            homeBadge: "Thuisbasis",
            note: "Staat uw plaats er niet tussen? Geen probleem. Op aanvraag rijden wij door heel Brabant en Nederland.",
        },
        how: {
            eyebrow: "Hoe het werkt",
            title: "In drie stappen onderweg",
            steps: [
                { title: "Bel, app of boek", text: "Geef vertrekpunt, bestemming en gewenst tijdstip door." },
                { title: "Directe bevestiging", text: "U ontvangt persoonlijk een bevestiging en de afgesproken ritprijs." },
                { title: "Wij halen u op", text: "De chauffeur staat op het afgesproken moment klaar." },
            ],
        },
        about: {
            eyebrow: "Over ons",
            title: "Nieuw, lokaal en persoonlijk",
            p1: "Taxi Drunnen is een nieuw, lokaal taxibedrijf uit Drunen, Noord-Brabant. Geen groot callcenter en geen wachtrij — u spreekt gewoon direct met de chauffeur die u ophaalt.",
            p2: "Wij geloven in korte lijnen en duidelijke afspraken. De prijs wordt vooraf afgesproken, de chauffeur staat op tijd klaar en onderweg reist u in alle rust in een verzorgde, zwarte auto. Dag en nacht, zeven dagen per week.",
            facts: [
                { label: "Bereikbaar", value: "24/7" },
                { label: "Thuisbasis", value: "Drunen" },
                { label: "Contact", value: "Direct" },
            ],
            callCta: "Liever direct bellen?",
            alt: "Chauffeur van Taxi Drunnen onderweg in de avond",
        },
        booking: {
            eyebrow: "Boeken",
            title: "Boek uw rit",
            text: "Vul het formulier in en verstuur uw aanvraag direct via WhatsApp. Wij bevestigen persoonlijk, met de ritprijs vooraf.",
            callAltLabel: "Liever direct bellen?",
            waAltLabel: "Direct appen kan ook",
            waAltTitle: "Open WhatsApp gesprek",
            labels: {
                naam: "Naam",
                telefoon: "Telefoonnummer",
                ophaaladres: "Ophaaladres",
                bestemming: "Bestemming",
                datum: "Datum",
                tijd: "Tijd",
                personen: "Aantal personen",
                soort: "Soort rit",
                opmerkingen: "Opmerkingen",
            },
            placeholders: {
                naam: "Uw naam",
                telefoon: "06 12 34 56 78",
                ophaaladres: "Straat, plaats",
                bestemming: "Waar mag het heen?",
                opmerkingen: "Bijv. vluchtnummer, kinderzitje, extra bagage…",
            },
            ritTypes: {
                regular: "Gewone taxirit",
                airport: "Luchthavenvervoer",
                business: "Zakelijk vervoer",
                daily: "Dagelijkse rit",
                event: "Evenement / feest",
                long: "Lange afstand",
                group: "Groepsvervoer",
            },
            submit: "Verstuur aanvraag via WhatsApp",
            note: "Geen online betaling nodig • Prijs wordt vooraf bevestigd",
            message: (f, ritLabel) =>
                [
                    "Hallo Taxi Drunnen, ik wil graag een rit aanvragen.",
                    "",
                    `Naam: ${f.naam}`,
                    `Telefoon: ${f.telefoon}`,
                    `Ophaaladres: ${f.ophaaladres}`,
                    `Bestemming: ${f.bestemming}`,
                    `Datum: ${f.datum}`,
                    `Tijd: ${f.tijd}`,
                    `Aantal personen: ${f.personen}`,
                    `Soort rit: ${ritLabel}`,
                    `Opmerkingen: ${f.opmerkingen || "-"}`,
                ].join("\n"),
        },
        reviews: {
            eyebrow: "Reviews",
            title: "Wat klanten zeggen",
            googleCta: "Beoordeel ons op Google",
            source: "Google-review",
        },
        contact: {
            eyebrow: "Contact — dag en nacht bereikbaar",
            titleA: "Bel. App. ",
            titleB: "Vertrek.",
            call: "Bel direct",
            whatsapp: "WhatsApp",
            book: "Boek een rit",
            note: "24/7 bereikbaar — Drunen, Noord-Brabant",
        },
        footer: {
            tagline: "Persoonlijk en betrouwbaar taxivervoer vanuit Drunen. Dag en nacht bereikbaar.",
            contactTitle: "Contact",
            available: "24/7 bereikbaar",
            place: "Drunen, Noord-Brabant",
            navTitle: "Navigatie",
            slogan: "Onderweg zonder omwegen",
        },
        pageTitles: {
            home: "Taxi Drunnen | Taxi Drunen 24/7 — Luchthavenvervoer & Straattaxi",
            diensten: "Diensten | Taxi Drunnen",
            werkgebied: "Werkgebied Drunen & omgeving | Taxi Drunnen",
            onzeTaxi: "Onze taxi — Passat Variant & Lynk & Co 01 | Taxi Drunnen",
            overOns: "Over ons | Taxi Drunnen",
            boeken: "Boek een rit | Taxi Drunnen",
            contact: "Contact — 24/7 bereikbaar | Taxi Drunnen",
        },
        mobile: { call: "Bellen", whatsapp: "WhatsApp", book: "Boek rit" },
    },
    en: {
        nav: {
            home: "Home",
            diensten: "Services",
            werkgebied: "Service area",
            onzeTaxi: "Our taxi",
            overOns: "About us",
            boeken: "Book",
            contact: "Contact",
            bookCta: "Book a ride",
            call: "Call",
            whatsapp: "WhatsApp",
        },
        hero: {
            eyebrow: "Your local taxi in Drunen — 24/7",
            line1: "On your way",
            line2a: "without ",
            line2b: "detours.",
            sub: "Personal and reliable taxi service from Drunen. Available day and night. You speak directly with the driver and know exactly what to expect.",
            call: "Call now",
            whatsapp: "WhatsApp",
            book: "Book a ride",
            scrollLabel: "Scroll to services",
            usps: [
                { title: "Available 24/7", text: "Day and night service" },
                { title: "Price agreed upfront", text: "No surprises afterwards" },
                { title: "Directly your driver", text: "You speak to the driver" },
            ],
        },
        marquee: [
            "Available 24/7",
            "Airport transfers",
            "Price agreed upfront",
            "Based in Drunen",
            "Business travel",
            "Directly your driver",
            "Schiphol & Eindhoven Airport",
            "Long distance",
        ],
        services: {
            eyebrow: "Services",
            title: "Where can we take you?",
            text: "From a short ride in Drunen to airport transfers across the Netherlands and Europe. Every ride arranged personally, with the price agreed upfront.",
            items: [
                {
                    title: "Airport transfers",
                    text: "Comfortable door-to-terminal transport. We follow your schedule and pick you up on time — early flights and late arrivals included.",
                    cta: "Book airport ride",
                },
                {
                    title: "Local taxi",
                    text: "Fast taxi rides in Drunen and surroundings. Call and we are on our way.",
                    cta: "Need a taxi? Call now",
                },
                {
                    title: "Business travel",
                    text: "Professional transport for companies, meetings, employees and guests. Invoicing available.",
                    cta: "Request business ride",
                },
                {
                    title: "Daily rides",
                    text: "For example hospital visits, groceries, family visits and appointments. Careful and on time.",
                    cta: "Plan your ride",
                },
                {
                    title: "Group transport",
                    text: "Transport for multiple passengers and groups, tailored to your party and schedule.",
                    cta: "Request group ride",
                },
                {
                    title: "Events & parties",
                    text: "Safe there and back, without worrying about parking or transport afterwards.",
                    cta: "Reserve transport",
                },
                {
                    title: "Long distance",
                    text: "Comfortable transport throughout the Netherlands and, on request, to destinations across Europe.",
                    cta: "Request a price",
                },
            ],
            longWa: "Hello Taxi Drunnen, I would like to request a price for a long-distance ride.",
        },
        taxi: {
            eyebrow: "Our taxi",
            title: "Two black cars. One standard.",
            text: "You always travel in a well-kept black car with plenty of room for you and your luggage. No preference? We assign the car that fits your ride best.",
            vehicles: [
                {
                    name: "Volkswagen Passat Variant",
                    code: "TD—01",
                    plate: "GZ-839-F",
                    tagline: "Comfortable estate — the quiet workhorse for long rides.",
                    features: ["Black", "Well-kept", "Comfortable", "Spacious", "Suitable for short and long rides"],
                    specs: [
                        { label: "Model year", value: "2015" },
                        { label: "Seats", value: "5" },
                        { label: "Luggage space", value: "Generous" },
                    ],
                    alt: "The black Volkswagen Passat Variant of Taxi Drunnen (GZ-839-F)",
                },
                {
                    name: "Lynk & Co 01",
                    code: "TD—02",
                    plate: "JBT-88-B",
                    tagline: "Modern plug-in hybrid SUV — silent in town, smooth on the motorway.",
                    features: ["Black", "Plug-in hybrid", "Modern and comfortable", "Spacious", "Suitable for short and long rides"],
                    specs: [
                        { label: "Model year", value: "2022" },
                        { label: "Seats", value: "5" },
                        { label: "Powertrain", value: "Hybrid" },
                    ],
                    alt: "The black Lynk & Co 01 of Taxi Drunnen (JBT-88-B)",
                },
            ],
        },
        why: {
            eyebrow: "Why Taxi Drunnen",
            title: "No call centre. Just your driver.",
            text: "Taxi Drunnen is new and local. That means personal attention and short lines of communication. You are not a number in a system.",
            points: [
                { title: "Direct contact", text: "You speak directly with the driver who handles your ride." },
                { title: "Price upfront", text: "The fare is agreed before departure. No surprises afterwards." },
                { title: "Day and night", text: "Available 24 hours a day, 7 days a week." },
            ],
            banner: "Question about a ride, price or destination? Feel free to message us — you will get a personal reply.",
            bannerCta: "Ask your question via WhatsApp",
        },
        area: {
            eyebrow: "Service area",
            title: "At home in Drunen. On the road across the Netherlands.",
            text: "Drunen is our home base. From here we drive daily in the region and far beyond.",
            homeBadge: "Home base",
            note: "Your town not listed? No problem. On request we drive throughout Brabant and the Netherlands.",
        },
        how: {
            eyebrow: "How it works",
            title: "On the road in three steps",
            steps: [
                { title: "Call, message or book", text: "Share your pickup point, destination and preferred time." },
                { title: "Instant confirmation", text: "You receive a personal confirmation and the agreed fare." },
                { title: "We pick you up", text: "The driver is ready at the agreed time." },
            ],
        },
        about: {
            eyebrow: "About us",
            title: "New, local and personal",
            p1: "Taxi Drunnen is a new, local taxi company from Drunen, Noord-Brabant. No big call centre and no queue — you simply speak directly with the driver who picks you up.",
            p2: "We believe in short lines and clear agreements. The price is agreed upfront, the driver arrives on time, and along the way you travel in peace in a well-kept black car. Day and night, seven days a week.",
            facts: [
                { label: "Available", value: "24/7" },
                { label: "Home base", value: "Drunen" },
                { label: "Contact", value: "Direct" },
            ],
            callCta: "Prefer to call directly?",
            alt: "Taxi Drunnen driver on the road in the evening",
        },
        booking: {
            eyebrow: "Book",
            title: "Book your ride",
            text: "Fill in the form and send your request directly via WhatsApp. We confirm personally, with the fare agreed upfront.",
            callAltLabel: "Prefer to call directly?",
            waAltLabel: "Messaging works too",
            waAltTitle: "Open WhatsApp chat",
            labels: {
                naam: "Name",
                telefoon: "Phone number",
                ophaaladres: "Pickup address",
                bestemming: "Destination",
                datum: "Date",
                tijd: "Time",
                personen: "Number of passengers",
                soort: "Type of ride",
                opmerkingen: "Comments",
            },
            placeholders: {
                naam: "Your name",
                telefoon: "+31 6 12 34 56 78",
                ophaaladres: "Street, town",
                bestemming: "Where to?",
                opmerkingen: "E.g. flight number, child seat, extra luggage…",
            },
            ritTypes: {
                regular: "Regular taxi ride",
                airport: "Airport transfer",
                business: "Business transport",
                daily: "Daily ride",
                event: "Event / party",
                long: "Long distance",
                group: "Group transport",
            },
            submit: "Send request via WhatsApp",
            note: "No online payment needed • Price confirmed upfront",
            message: (f, ritLabel) =>
                [
                    "Hello Taxi Drunnen, I would like to request a ride.",
                    "",
                    `Name: ${f.naam}`,
                    `Phone: ${f.telefoon}`,
                    `Pickup address: ${f.ophaaladres}`,
                    `Destination: ${f.bestemming}`,
                    `Date: ${f.datum}`,
                    `Time: ${f.tijd}`,
                    `Number of passengers: ${f.personen}`,
                    `Type of ride: ${ritLabel}`,
                    `Comments: ${f.opmerkingen || "-"}`,
                ].join("\n"),
        },
        reviews: {
            eyebrow: "Reviews",
            title: "What customers say",
            googleCta: "Review us on Google",
            source: "Google review",
        },
        contact: {
            eyebrow: "Contact — available day and night",
            titleA: "Call. Message. ",
            titleB: "Go.",
            call: "Call now",
            whatsapp: "WhatsApp",
            book: "Book a ride",
            note: "Available 24/7 — Drunen, Noord-Brabant",
        },
        footer: {
            tagline: "Personal and reliable taxi service from Drunen. Available day and night.",
            contactTitle: "Contact",
            available: "Available 24/7",
            place: "Drunen, Noord-Brabant",
            navTitle: "Navigation",
            slogan: "On the road without detours",
        },
        pageTitles: {
            home: "Taxi Drunnen | 24/7 Taxi in Drunen — Airport transfers & local rides",
            diensten: "Services | Taxi Drunnen",
            werkgebied: "Service area Drunen & surroundings | Taxi Drunnen",
            onzeTaxi: "Our taxi — Passat Variant & Lynk & Co 01 | Taxi Drunnen",
            overOns: "About us | Taxi Drunnen",
            boeken: "Book a ride | Taxi Drunnen",
            contact: "Contact — available 24/7 | Taxi Drunnen",
        },
        mobile: { call: "Call", whatsapp: "WhatsApp", book: "Book ride" },
    },
};

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
    const [lang, setLang] = useState(() => {
        try {
            return localStorage.getItem("td-lang") || "nl";
        } catch {
            return "nl";
        }
    });

    useEffect(() => {
        try {
            localStorage.setItem("td-lang", lang);
        } catch {}
        document.documentElement.lang = lang;
    }, [lang]);

    return (
        <LanguageContext.Provider value={{ lang, setLang, t: translations[lang] }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLang = () => useContext(LanguageContext);
